var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-row", { staticClass: "pa-6", attrs: { justify: "center" } }, [
    _c("span", { staticClass: "title" }, [
      _vm._v(" " + _vm._s(_vm.otsikko) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }